import {googleClientId, googleScript} from "config";

let auth2: any = null;
let tryAutoLogin = true;

export const loadGoogleScript = (url: string, callback: () => void) => {
    const script = document.createElement("script");
    script.src = url;
    script.id = "gScript";
    document.body.appendChild(script);
    script.onload = () => {
      callback();
    };
};

export function bindGapiObjectToButton(btnNames: string[], callback, errorCallback?) {
    loadGoogleScript(googleScript, () => {
        (window as  any)?.gapi?.load("auth2", () => {
            auth2 = (window as  any).gapi.auth2.init({
                client_id: googleClientId,
                cookiepolicy: "single_host_origin",
            });
            btnNames.forEach((b) => attachSignin(document.getElementById(b), callback));
            auth2.currentUser.listen((googleUser) => {
                if (googleUser.getAuthResponse().hasOwnProperty("id_token") && tryAutoLogin) {
                    callback(googleUser);
                } else {
                    errorCallback();
                    tryAutoLogin = false;
                }
            });
        });
    });
}
function attachSignin(element, callback) {
    auth2.attachClickHandler(element, {},
        (googleUser) => {
            callback(googleUser);
        }, (error) => {
            return;
    });
}
